/**
 *
 * Asynchronously loads the component for Individiual
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Individiual = lazyLoad(
  () => import('./index'),
  module => module.SequentialSteps,
);
